import { render, staticRenderFns } from "./FileDropLayout.vue?vue&type=template&id=094b0ffa&"
import script from "./FileDropLayout.vue?vue&type=script&lang=js&"
export * from "./FileDropLayout.vue?vue&type=script&lang=js&"
import style0 from "./FileDropLayout.vue?vue&type=style&index=0&id=094b0ffa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VIcon,VImg,VProgressCircular,VProgressLinear,VTextarea})
